<template>
    <li class="flex flex-row items-center gap-2">
        <RouterLink
            class="flex flex-row border-b border-b-sky-800 hover:border-b-sky-900 active:border-b-sky-950 items-center text-sky-800 hover:text-sky-900 active:text-sky-950 focus-visible:outline-offset-2 focus-visible:outline-2 focus-visible:outline-sky-700 leading-tight"
            :to="target"
        >
            <slot />
        </RouterLink>
        <ChevronRightIcon class="text-gray-500 shrink-0" />
    </li>
</template>

<script setup lang="ts">
import { RouteLocationRaw, RouterLink } from 'vue-router';
import ChevronRightIcon from '../Icon/ChevronRightIcon.vue';

type BreadcrumbLinkProps = {
    target: RouteLocationRaw;
};

defineProps<BreadcrumbLinkProps>();
</script>
